
import cx from 'classnames'
import { MdWarning } from 'react-icons/md'
import { Link } from 'react-router-dom'

import { useTodos } from '../../../dashboard/queries/todos'
import { Domain } from '../../../igao/shared'
import { diffDate } from '../../../igao/utils'
import { NoDataPlaceHolder } from '../../../PatientFolder/behavioral/components'
import * as Sidebar from '../components'

import styles from './tasks.module.css'

export const DOMAIN_LIST = [
  {
    name: 'Review of Systems',
    id: 'Ox',
    value: 'DRS',
    type: 'Care Insights'
  }, {
    name: 'Pain and Symptoms',
    id: 'Sx',
    value: 'DPS',
    type: 'Care Insights'
  }, {
    name: 'Patient / Family / Community',
    id: 'Fx',
    value: 'DPFC',
    type: 'Care Insights'
  },
  {
    name: 'Treatment Plan',
    id: 'Tx',
    value: 'DTP',
    type: 'Care Insights'
  }, {
    name: 'Benefit Design and Coverage',
    id: 'Bx',
    value: 'DBDC',
    type: 'Care Insights'
  }, {
    name: 'Provider Access Evaluation',
    id: 'Ax',
    value: 'DPAE',
    type: 'Care Insights'
  }, {
    name: 'Goals and EOL Planning',
    id: 'Gx',
    value: 'DGEP',
    type: 'Care Insights'
  }, {
    name: 'Knowledge and Choice',
    id: 'Kx',
    value: 'DKC',
    type: 'Care Insights'
  }, {
    name: 'Medications / Allergies',
    id: 'Rx',
    value: 'DMA',
    type: 'Clinical Insights'
  }, {
    name: 'Hospitalizations / ED visits',
    id: 'Ex',
    value: 'DHEDV',
    type: 'Clinical Insights'
  }, {
    name: 'Physical Exam',
    id: 'Px',
    value: 'DPE',
    type: 'Clinical Insights'
  }, {
    name: 'Past Medical History',
    id: 'Hx',
    value: 'DPMH',
    type: 'Clinical Insights'
  }, {
    name: 'Demographics',
    id: 'Nx',
    value: 'DDEM',
    type: 'Clinical Insights'
  }, {
    name: 'Vitals',
    id: 'Vx',
    value: 'DV',
    type: 'Clinical Insights'
  }
]

export function Tasks (): JSX.Element {
  const { data, isLoading } = useTodos({ scope: 'mine' }, { field: 'nextDueDate', direction: 'asc' })

  const tasksLength = data?.rows?.length ?? 0

  return (
    <>
      <Sidebar.Header
        link='/tasks'
        linkTitle='Go to tasks page'
      >
        Tasks {tasksLength ?? ''}
      </Sidebar.Header>
      <Sidebar.Wrapper>
        {tasksLength <= 0 && !isLoading && (
          <NoDataPlaceHolder
            title='There are no Tasks to display'
            className='bg-transparent'
          />
        )}

        <Sidebar.Cards>
          {data?.rows?.map((task, key) => {
            const domain = DOMAIN_LIST.find((domain) => domain.name === task.domain)?.id
            const dueDate = Math.ceil(diffDate(task.dueDate, null))

            return (
              <Sidebar.Card key={key}>
                <Link
                  title='Patient Folder'
                  to={`/patient/${task.clientName}/${task.patientId}`}
                  className='-mr-4 px-4 flex items-start w-full'
                >
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.7rem', flex: 1 }}>
                    <div style={{ display: 'flex', gap: '0.3rem', alignItems: 'center', marginLeft: '-8px' }}>
                      <div style={{ transform: 'scale(0.72)' }}>
                        <Domain domain={domain} />
                      </div>
                      <span style={{ fontSize: '12px', color: 'black' }}>
                        {task.patientName}
                      </span>
                    </div>
                    <div
                      dangerouslySetInnerHTML={{ __html: task.description }}
                      className='text-black'
                    />
                  </div>
                  <div className='flex flex-row items-center gap-4 mt-1'>
                    {task.urgent && (
                      <MdWarning
                        color='#F2545A'
                        size='1.2rem'
                      />
                    )}
                    {typeof dueDate === 'number' && !isNaN(dueDate) && (
                      <div className={cx(styles.dueDate, [ dueDate < 0 ? styles.red : styles.blue ])}>
                        {Math.abs(dueDate)}
                      </div>
                    )}
                  </div>
                </Link>
              </Sidebar.Card>
            )
          })}
        </Sidebar.Cards>
      </Sidebar.Wrapper>
    </>
  )
}
